module.exports = __webpack_public_path__ + "img/bottom.6d6de6ef.svg";